import React from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons
import PermDataSetting from '@material-ui/icons/PermDataSetting'

import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import Paper from '@material-ui/core/Paper'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import CardActions from '@material-ui/core/CardActions'
// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'

import userSettingsStyles from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx'
import DropdownUsers from '../Components/DropdownUsers'
import { updateOne, retrieveUserSettings } from '../../services/generalServiceAPI'
import AppContext from '../../services/context'
import { dayDiff, logger, jsonPP } from '../utility/utility'

import swal from 'sweetalert'

class UserSettings extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: {
        button: 'Update',
        title: `Update Settings ` //${this.context.user.name}
      },
      data: {
        tableName: 'users',
        isOnVacation: false,
        // startDate: '',
        // endDate: '',
        delegate: {},
        dashboardTheme: '2',
        emailOption: ''
      },
      dataState: {},
      dirty: false
    }

    this.save = this.save.bind(this)
    this.change = this.change.bind(this)
  }
  static contextType = AppContext

  change(event) {
    // for checkout and switch
    if (event.target.id === 'isOnVacation') {
      this.setState({
        data: { ...this.state.data, [event.target.id]: event.target.checked },
        dirty: true
      })
    } else {
      // for text and radio
      const data = { ...this.state.data, [event.target.id]: event.target.value }
      if (dayDiff(data.startDate, data.endDate) < 0) {
        swal('Error', 'The end date needs to be later than the start date.', 'error', { timer: 5000 })
      } else {
        this.setState({
          data,
          dirty: true
        })
      }
    }
  }
  handleDropdown = name => value => {
    const { data, dataState } = this.state

    data[name] = value

    dataState[name] = 'success'
    this.setState({
      data,
      dataState,
      dirty: true
    })
  }
  save() {
    // only save user id for delegate
    // add id of the currently login user
    let { delegate, ...others } = this.state.data
    const dataToSave = { id: this.context.user.id, ...others, delegate: delegate.value }
    updateOne(dataToSave)
      .then(response => {
        if (response.ok) {
          return response.json()
        } else
          swal(response.url, {
            icon: 'error'
          })
      })
      .then(res => {
        const recordId = res.id ? res.id : this.context.user.id
        swal({ text: 'This record has beend saved - ' + recordId, icon: 'success', timer: 2000 })
        this.context.user.dashboardTheme = this.state.data.dashboardTheme
        this.context.user.emailOption = this.state.data.emailOption
        this.setState({
          data: {
            ...this.state.data,
            id: res.id
          },
          dirty: false
        })
      })
      .catch(e => swal(`apollo throw error: ${e}`))
  }
  async componentDidMount() {
    try {
      await retrieveUserSettings({ id: this.context.user.id }).then(({ data }) => {
        logger('UserSettings: componentDidMount', data)
        const { isOnVacation = false,  delegate, dashboardTheme = '2', emailOption = '1' } = data.user
        this.setState({
          data: {
            ...this.state.data,
            isOnVacation,
            // startDate,
            // endDate,
            emailOption,
            dashboardTheme,
            delegate: {
              value: delegate ? delegate.id : '',
              label: delegate ? delegate.name : ''
            }
          }
        })
      })
    } catch (e) {
      logger('UserSettings: componentDidMount', e, true)
    }
  }
  render() {
    const { classes } = this.props
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='rose' icon>
                <CardIcon color='rose'>
                  <PermDataSetting />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{this.state.text.title}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  {/* vacation settings */}
                  <GridItem xs={12}>
                    <Paper className={classes.settingGroup}>
                      <GridContainer>
                        <GridItem xs={12}>
                          <FormLabel component='legend' className={classes.settingGroupTitle}>
                            Vacation Settings:
                          </FormLabel>
                        </GridItem>
                        <GridItem xs={12}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={this.state.data.isOnVacation}
                                id='isOnVacation'
                                onChange={this.change}
                                value={'isOnVacation'}
                                classes={{
                                  switchBase: classes.switchBase,
                                  checked: classes.switchChecked,
                                  icon: classes.switchIcon,
                                  iconChecked: classes.switchIconChecked,
                                  bar: classes.switchBar
                                }}
                                // disabled
                              />
                            }
                            classes={{
                              label: classes.label
                            }}
                            labelPlacement='start'
                            label='Set my vacation status to be '
                          />
                        </GridItem>
                        <GridItem xs={12}>
                          <FormControlLabel
                            control={
                              <DropdownUsers
                                id='delegate'
                                isDisabled={!this.state.data.isOnVacation}
                                className={classes.textField}
                                onChange={this.handleDropdown('delegate')}
                                companyId={this.context.user.companyId}
                                // loose
                                helperText={'Choose a delegate ...'}
                                value={this.state.data.delegate}
                              />
                            }
                            classes={{
                              label: classes.label
                            }}
                            labelPlacement='start'
                            label='Your delegate while you are absent: '
                          />
                        </GridItem>
                      </GridContainer>
                    </Paper>
                  </GridItem>
                  <GridItem xs={12}>
                    <Paper className={classes.settingGroup}>
                      <GridContainer>
                        <GridItem xs={12}>
                          <FormLabel component='legend' className={classes.settingGroupTitle}>
                            Theme of Dashboard
                          </FormLabel>
                        </GridItem>

                        <GridItem xs={12}>
                          <RadioGroup aria-label='email' className={classes.group} value={this.state.data.dashboardTheme} onChange={this.change}>
                            <FormControlLabel className={classes.label} value='1' control={<Radio id='dashboardTheme' />} label='Tabular' />
                            <FormControlLabel className={classes.label} value='2' control={<Radio id='dashboardTheme' />} label='Tiling' />
                          </RadioGroup>
                        </GridItem>
                      </GridContainer>
                    </Paper>
                  </GridItem>
                  <GridItem xs={12}>
                    <Paper className={classes.settingGroup}>
                      <GridContainer>
                        <GridItem xs={12}>
                          <FormLabel component='legend' className={classes.settingGroupTitle}>
                            {' '}
                            Options for Email Subscription :{' '}
                          </FormLabel>
                        </GridItem>

                        <GridItem xs={12}>
                          <RadioGroup aria-label='email' className={classes.group} value={this.state.data.emailOption} onChange={this.change}>
                            <FormControlLabel
                              className={classes.label}
                              value='1'
                              control={<Radio id='emailOption' />}
                              label='Receive email on every step of signing'
                              disabled
                            />
                            <FormControlLabel
                              className={classes.label}
                              value='2'
                              control={<Radio id='emailOption' />}
                              label='Only receive email when the appilication is completely approved or rejected.'
                              disabled
                            />
                          </RadioGroup>
                        </GridItem>
                      </GridContainer>
                    </Paper>
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardActions className={classes.actions} disableActionSpacing>
                <Button style={{ marginLeft: 'auto' }} color='rose' className={classes.buttons} disabled={!this.state.dirty} onClick={this.save}>
                  Save
                </Button>
              </CardActions>
            </Card>
          </GridItem>
        </GridContainer>
        {jsonPP(this.state)}
      </div>
    )
  }
}

export default withStyles(userSettingsStyles)(UserSettings)
//      {jsonPP(this.state)}
